<template>
  <div class="dashboard-block" v-if="!booking.is_offer">
    <h2>
      {{ $starLabel | sentenceCase }} Notifications

      <a v-if="userCanNotifyTalent" data-toggle="modal" data-backdrop="static" data-target="#talent-nofications-modal" class="btn btn-sm pull-right"><i class="fa fa-plus"></i> Add {{ $starLabelPlural | sentenceCase}}</a>
    </h2>

    <div v-if="haveNoTalentNotified" class="text-center alert alert-default">
      There are no notified {{ $starLabelPlural }}.
    </div>

    <ul v-else class="tags">
      <li v-for="talent in booking.talent_notified" :key="talent.id">
        <span>{{ talent.name }}</span>
      </li>
    </ul>

    <booking-talent-notifications-modal
      ref="modal"
      :booking="booking"
      :recommendations="recommendations"
      :send-talent-notifications-callback="handleSendTalentNotificationsCallback"/>
  </div>
</template>

<script>
import { helpers } from 'mixins/bookings'
import { mapActions } from 'vuex'
import BookingTalentNotificationsModal from './BookingTalentNotificationsModal'
import $ from 'jquery'

export default {
  mixins: [helpers],

  props: {
    booking: {
      required: true,
      type: Object
    },
    recommendations: {
      required: true,
      type: Array
    }
  },

  components: {
    BookingTalentNotificationsModal
  },

  data () {
    return {
      talentToAdd: []
    }
  },

  computed: {
    haveNoTalentNotified () {
      return this.booking.talent_notified && this.booking.talent_notified.length === 0
    },

    userCanNotifyTalent () {
      if (this.$userIsNonGlobalAdmin) {
        return this.booking.region_id === this.$user.region_id
      }

      return true
    }
  },

  methods: {
    ...mapActions('booking/request', ['sendTalentNotifications']),

    /**
     * Handle sending the notification to the talent.
     *
     * @return Promise
     */
    handleSendTalentNotificationsCallback (talent) {
      let payload = {
        id: this.booking.id,
        payload: {
          talent
        }
      }

      return this.sendTalentNotifications(payload)
        .then(() => {
          $(this.$refs.modal.$el).modal('hide')
        })
    }
  }
}
</script>
